import * as React from 'react';

import Common from '../../stores/Common';
import { IReportDepositionModel } from '../../interfaces/Report/ITimelineReport';
import { Link } from 'react-router-dom';
import { LocalRoutes } from '../../utilities/LocalRoutes';
import Sort from '../../stores/Sort';
import { SortableHeader } from '../shared/SortableHeader';
import { ZoneContextType } from '../../utilities/Constants';

interface IReportDepositionListProps {
    depositions: IReportDepositionModel[];
    zoneContext: ZoneContextType;
}

interface IReportDepositionListState {
    depositions: IReportDepositionModel[];
}

export class ReportDepositionList extends React.Component<
    IReportDepositionListProps,
    IReportDepositionListState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            depositions: [],
        };
    }

    componentDidMount() {
        if (this.props.depositions) {
            this.setState({
                depositions: this.props.depositions,
            });
        }
    }

    componentDidUpdate(prevProps: IReportDepositionListProps) {
        if (prevProps.depositions != this.props.depositions) {
            this.setState({
                depositions: this.props.depositions,
            });
        }
    }

    sortData = (key: string, order: string, subKey?: string, subGrandKey?: string) => {
        let depositions = this.state.depositions;
        if (key.includes('date')) {
            depositions = depositions.sort(Sort.compareDate(key, subKey, order));
        } else {
            depositions = depositions.sort(Sort.compareValues(key, subKey, order, subGrandKey));
        }

        this.setState({ depositions: depositions });
    };

    render() {
        return (
            <table className="table table-sm">
                <thead>
                    <tr style={{ verticalAlign: 'middle' }}>
                        <SortableHeader
                            headerText="Case Name"
                            sortKey="caseName"
                            onSort={this.sortData}
                            thClassName="col-sm-2"
                            noWrap
                        />
                        <SortableHeader
                            headerText="Case Status"
                            sortKey="caseStatus"
                            subKey="displayName"
                            onSort={this.sortData}
                            thClassName="col-sm-1"
                            noWrap
                        />
                        <SortableHeader
                            headerText="SQ Score"
                            sortKey="qScore"
                            onSort={this.sortData}
                            thClassName="col-sm-1"
                            noWrap
                        />
                        <SortableHeader
                            headerText="Jurisdiction"
                            sortKey="jurisdiction"
                            onSort={this.sortData}
                            thClassName="col-sm-2"
                        />
                        <SortableHeader
                            headerText="Plaintiffs Firm"
                            sortKey="plaintiffsFirm"
                            onSort={this.sortData}
                            thClassName="col-sm-2"
                            noWrap
                        />
                        <SortableHeader
                            headerText="Deposition"
                            sortKey="category"
                            onSort={this.sortData}
                            subKey="displayName"
                            thClassName="col-sm-1"
                        />
                        <SortableHeader
                            headerText="Witness Title"
                            sortKey="title"
                            onSort={this.sortData}
                            thClassName="col-sm-1"
                            noWrap
                        />
                        <SortableHeader
                            headerText="Status"
                            sortKey="status"
                            subKey="displayName"
                            onSort={this.sortData}
                            thClassName="col-sm-1"
                        />
                        <SortableHeader
                            headerText="Date"
                            sortKey="date"
                            onSort={this.sortData}
                            thClassName="col-sm-1"
                        />
                    </tr>
                </thead>
                <tbody>
                    {this.state.depositions && this.state.depositions.length > 0
                        ? this.state.depositions.map((item: IReportDepositionModel, i: number) => {
                              return (
                                  <tr key={i}>
                                      <td className="col-sm-2">
                                          <Link
                                              target="_blank"
                                              to={this.props.zoneContext.buildZoneUrl(LocalRoutes.CaseFile.replace(
                                                  ':guid',
                                                  item.caseGuid
                                              ))}
                                          >
                                              {item.caseName}
                                          </Link>
                                      </td>
                                      <td className="col-sm-1">{item.caseStatus!.displayName}</td>
                                      <td className="col-sm-1">{item.qScore}</td>
                                      <td className="col-sm-2">{item.jurisdiction}</td>
                                      <td className="col-sm-2">{item.plaintiffsFirm}</td>
                                      <td className="col-sm-1">{item.category!.displayName}</td>
                                      <td className="col-sm-1">{item.title}</td>
                                      <td className="col-sm-1">{item.status!.displayName}</td>
                                      <td className="col-sm-1">{Common.dateFormat(item.date)}</td>
                                  </tr>
                              );
                          })
                        : null}
                </tbody>
            </table>
        );
    }
}
